import { MemoryReactionsStore } from '@atlaskit/reactions';

import { MetricName, ReliabilityMetrics } from '@canvas/frontend-metrics';

import { getReactionsClient } from './reactions-client';

let reactionsStore: MemoryReactionsStore;

export const getReactionsStore = (reactionsClient = getReactionsClient()) => {
  if (!reactionsStore) {
    const intialState = {
      reactions: {},
      flash: {},
      particleEffectByEmoji: {},
    };

    const client = {
      getReactions(containerAri: string, commentAris: string[]) {
        return reactionsClient
          .getReactions({
            containerAri,
            commentAris,
          })
          .then((data) => {
            ReliabilityMetrics.getInstance().success(MetricName.COMMENT_INTERACTION, {
              commentAction: 'get-reactions-for-comment',
            });
            return data;
          })
          .catch((e: unknown) => {
            const msg = e instanceof Error ? e.message : String(e);
            ReliabilityMetrics.getInstance().failure(MetricName.COMMENT_INTERACTION, {
              commentAction: 'get-reactions-for-comment',
              errorMessage: msg,
            });
            throw e;
          });
      },
      getDetailedReaction(containerAri: string, commentAri: string, emojiId: string) {
        return reactionsClient
          .getDetailedReaction({
            commentAri,
            containerAri,
            emojiId,
          })
          .then((data) => {
            ReliabilityMetrics.getInstance().success(MetricName.COMMENT_INTERACTION, {
              commentAction: 'get-detailed-reactions-for-comment',
            });
            return data;
          })
          .catch((e: unknown) => {
            const msg = e instanceof Error ? e.message : String(e);
            ReliabilityMetrics.getInstance().failure(MetricName.COMMENT_INTERACTION, {
              commentAction: 'get-detailed-reactions-for-comment',
              errorMessage: msg,
            });
            throw e;
          });
      },
      async addReaction(containerAri: string, commentAri: string, emojiId: string) {
        try {
          await reactionsClient.addReaction({
            commentAri,
            containerAri,
            emojiId,
          });
          ReliabilityMetrics.getInstance().success(MetricName.COMMENT_INTERACTION, {
            commentAction: 'add-reactions-for-comment',
          });
          // Result is unused by @atlaskit/reactions
          return [];
        } catch (e: unknown) {
          const msg = e instanceof Error ? e.message : String(e);
          ReliabilityMetrics.getInstance().failure(MetricName.COMMENT_INTERACTION, {
            commentAction: 'add-reactions-for-comment',
            errorMessage: msg,
          });
          throw e;
        }
      },
      async deleteReaction(containerAri: string, commentAri: string, emojiId: string) {
        try {
          await reactionsClient.removeReaction({
            commentAri,
            containerAri,
            emojiId,
          });
          ReliabilityMetrics.getInstance().success(MetricName.COMMENT_INTERACTION, {
            commentAction: 'delete-reactions-for-comment',
          });
          // Result is unused by @atlaskit/reactions
          return [];
        } catch (e: unknown) {
          const msg = e instanceof Error ? e.message : String(e);
          ReliabilityMetrics.getInstance().failure(MetricName.COMMENT_INTERACTION, {
            commentAction: 'delete-reactions-for-comment',
            errorMessage: msg,
          });
          throw e;
        }
      },
    };

    reactionsStore = new MemoryReactionsStore(client, intialState);
  }

  return reactionsStore;
};
